export default {"src":"/_next/static/media/0xd24c2ad096400b6fbcd2ad8b24e7acbc21a1da64.668df216.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};